import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListBook from "./ListBook";
import {
  SelectAcademicYear,
  SelectStudentByAcademicYear,
  SelectWarehouse,
} from "../Include/DynamicSelect";
import { UPDATE_STUDENT_RENT_MATERIAL } from "../../Schema/StudentRent";

export default function UpdateStudentRent({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  //
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [requiredField, setRequiredField] = useState(false);

  // =============== List Item Set ===================
  const book = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    condition: "",
    key: Date.now() + Math.random(),
  };

  const [bookList, setBookList] = useState([book]);

  const handleAddListBook = () => {
    setBookList([...bookList, book]);
  };

  const handleUpdateListBook = (key, val, fieldName) => {
    const newBook = bookList?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = val;
        }
        if (key === d.key && fieldName === "qty") {
          d.qty = parseFloat(val);
        }
        if (key === d.key && fieldName === "condition") {
          d.condition = val;
        }
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleDeleteListBook = (key) => {
    const handleDeleteList = bookList?.filter((d) => d.key !== key);
    setBookList([...handleDeleteList]);
  };
  // ================== End List Item =================

  // ================= Function Create Student Book ===============
  const [updateRentMaterial] = useMutation(UPDATE_STUDENT_RENT_MATERIAL, {
    onCompleted: ({ updateRentMaterial }) => {
      setLoading(false);
      if (updateRentMaterial?.status) {
        setAlert(true, "success", updateRentMaterial?.message);
        handleClose();
        resetForm();
        setRefetch();
        setBookList([book]);
        setStudentVal({ id: "", title: "" });
        setWarehouseVal({ id: "", title: "" });
      } else {
        setAlert(true, "error", updateRentMaterial?.message);
        console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error?.message);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required("require!"),
    studentId: Yup.string().required("require!"),
    warehouseId: Yup.string().required("require!"),
    remark: Yup.string(),
    dateTime: Yup.date().required("require!"),
    dueDate: Yup.date().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      studentId: "",
      warehouseId: "",
      remark: "",
      dateTime: new Date(),
      dueDate: new Date(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        bookList?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty >= 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      //
      if (createStatus) {
        //
        let listItemRentToSubmit = bookList?.map((d) => {
          return {
            warehouseId: values?.warehouseId,
            condition: d?.condition,
            dueDate: moment(values?.dueDate)?.format("YYYY-MM-DD"),
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: d?.qty,
          };
        });

        const payload = {
          academicYearId: values?.academicYearId,
          studentId: values?.studentId,
          desc: values?.remark,
          dateTime: moment(values?.dateTime).toISOString(),
          rentBy: "",
          returnStatus: "not_yet_returned",
          rentMaterialItems: listItemRentToSubmit,
        };

        // console.log("listItemRentToSubmit::::", listItemRentToSubmit);
        setLoading(true);
        updateRentMaterial({
          variables: {
            id: editData?._id,
            input: payload,
          },
        });
        // updateRentMaterial({
        //   variables: {
        //     id: editData?._id,
        //     input: {
        //       dateTime: values?.dateTime,
        //       desc: values?.remark,
        //       rentBy: "",
        //       studentId: values?.studentId,
        //       rentMaterialItems: listItemRentToSubmit,
        //     },
        //   },
        // });
      }
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;

  // console.log("editData", editData?.academicYearId);

  //================== When Change Student ======================
  useEffect(() => {
    setFieldValue("academicYearId", academicYearVal?.id || "");
  }, [academicYearVal?.id]);

  useEffect(() => {
    setFieldValue("studentId", studentVal?.id || "");
  }, [studentVal?.id]);

  //==================== When Change Warehouse ==================
  useEffect(() => {
    setFieldValue("warehouseId", warehouseVal?.id || "");
  }, [warehouseVal?.id, open]);

  useEffect(() => {
    if (editData) {
      // console.log(editData);
      setStudentVal({
        id: editData?.studentId?._id,
        title:
          editData?.studentId?.englishName +
          " - " +
          editData?.studentId?.lastName +
          " " +
          editData?.studentId?.firstName,
      });
      setAcademicYearVal({
        id: editData?.academicYearId?._id,
        title: editData?.academicYearId?.academicYear,
      });

      setFieldValue("remark", editData?.desc);
      setFieldValue("returnStatus", editData?.returnStatus);

      if (editData?.rentMaterialItems) {
        let listRentItem = [];
        editData?.rentMaterialItems?.map((rowRent, index) => {
          // Find Return Item
          let returnMaterial = [];

          if (rowRent?.returnRentMaterialItems?.length > 0) {
            rowRent?.returnRentMaterialItems?.map((rowReturn, index) => {
              returnMaterial.push({
                key: index,
                isOld: true,
                condition: rowReturn?.condition,
                qty: rowReturn?.qty,
                desc: rowReturn?.desc,
                warehouseId: {
                  id: rowReturn?.warehouseId?._id,
                  title: rowReturn?.warehouseId?.warehouseName,
                },
              });
            });
          }

          listRentItem.push({
            materialId: {
              id: rowRent?.listMaterialUnitId?.materialId?._id,
              title: rowRent?.listMaterialUnitId?.materialId?.materialEnName,
              fullName: rowRent?.listMaterialUnitId?.materialId?.materialEnName,
            },
            listMaterialUnitId: {
              id: rowRent?.listMaterialUnitId?._id,
              title: rowRent?.listMaterialUnitId?.unitId?.unitKhName,
              imageSrc: rowRent?.listMaterialUnitId?.imageSrc,
            },
            rentMaterialItemId: rowRent?._id,
            returnMaterial: returnMaterial,
            qty: rowRent?.qty,
            condition: rowRent?.condition,
            key: Math.random() + index,
          });
        });
        setBookList(listRentItem);
      }
    }
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតជួលសម្ភារៈ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំង</Typography>
                <SelectWarehouse
                  selectedVal={warehouseVal}
                  setSelectedVal={setWarehouseVal}
                  defaultValue={true}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">កាលបរិច្ចេទជួល</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={values?.dateTime}
                    onChange={(newValue) => {
                      setFieldValue("dateTime", newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">
                  កាលបរិច្ចេទប្រគល់
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={values?.dueDate}
                    onChange={(newValue) => {
                      setFieldValue("dueDate", newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicYearVal}
                  setSelectedVal={setAcademicYearVal}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">ឈ្មោះសិស្ស</Typography>
                <SelectStudentByAcademicYear
                  selectedVal={studentVal}
                  setSelectedVal={setStudentVal}
                  academicYearId={academicYearVal?.id}
                  disabled={academicYearVal?.id ? false : true}
                />
                {!!errors.studentId && touched.studentId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.studentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <ListBook
                  handleDeleteList={handleDeleteListBook}
                  handleUpdateList={handleUpdateListBook}
                  handleAddList={handleAddListBook}
                  warehouseId={warehouseVal?.id}
                  requiredField={requiredField}
                  bookList={bookList}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
